import { useMemo, useState } from "react";
import { ReactTableDataGrid } from "components/Table";
import { getSizePerPageList } from "helper/constant";

const ShopData = ({ data = [], totalSize = 0, onTableChange }) => {
    const [sizePerPage, setSizePerPage] = useState(10);
    const defaultColDef = useMemo(
        () => ({
            wrapText: true,
            autoHeight: true,
            autoHeaderHeight: true,
        }),
        []
    );

    const columns = [
        {
            field: "_id",
            width: 30,
            cellClass: "centered-cell",
            headerName: "",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
        },
        {
            field: "shopInfo",
            cellClass: "centered-cell",
            headerName: "Shop Info",
            flex: 1,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <div>
                    <p>{row.name}</p>
                    <span>
                        {row.note} - {row.member_note}
                    </span>
                </div>
            ),
            comparator: (_cellA, _cellB, { data: valueA }, { data: valueB }) => {
                if (valueA?.name < valueB?.name) return -1;
                if (valueA?.name > valueB?.name) return 1;
                return 0;
            },
        },
        {
            field: "totalListing",
            flex: 1,
            cellClass: "centered-cell",
            headerName: "Total Listing",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => row?.totalProductProductListing || 0,
            comparator: (_cellA, _cellB, { data: valueA }, { data: valueB }) => {
                if (valueA?.totalProductProductListing < valueB?.totalProductProductListing) return -1;
                if (valueA?.totalProductProductListing > valueB?.totalProductProductListing) return 1;
                return 0;
            },
        },
        {
            field: "totalActive",
            cellClass: "centered-cell",
            headerName: "Total Active",
            flex: 1,
            cellRenderer: ({ rowIndex, value: cell, data: row }) =>
                row?.tiktokProducts.filter((i) => i.apiStatus === "ACTIVATE")?.length || 0,
            comparator: (_cellA, _cellB, { data: valueA }, { data: valueB }) => {
                const a = valueA?.tiktokProducts.filter((i) => i.apiStatus === "ACTIVATE")?.length || 0;
                const b = valueB?.tiktokProducts.filter((i) => i.apiStatus === "ACTIVATE")?.length || 0;
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            },
        },
        {
            field: "totalPending",
            cellClass: "centered-cell",
            headerName: "Total Pending",
            flex: 1,
            cellRenderer: ({ rowIndex, value: cell, data: row }) =>
                row?.tiktokProducts.filter((i) => i.apiStatus === "PENDING")?.length || 0,
            comparator: (_cellA, _cellB, { data: valueA }, { data: valueB }) => {
                const a = valueA?.tiktokProducts.filter((i) => i.apiStatus === "PENDING")?.length || 0;
                const b = valueB?.tiktokProducts.filter((i) => i.apiStatus === "PENDING")?.length || 0;
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            },
        },
        {
            field: "totalProductSuccess",
            flex: 1,
            cellClass: "centered-cell",
            headerName: "Total Success",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => cell || 0,
        },
        {
            field: "totalFailed",
            cellClass: "centered-cell",
            headerName: "Total Failed",
            flex: 1,
            cellRenderer: ({ rowIndex, value: cell, data: row }) =>
                row?.tiktokProducts.filter((i) => i.apiStatus === "FAILED")?.length || 0,
            comparator: (_cellA, _cellB, { data: valueA }, { data: valueB }) => {
                const a = valueA?.tiktokProducts.filter((i) => i.apiStatus === "FAILED")?.length || 0;
                const b = valueB?.tiktokProducts.filter((i) => i.apiStatus === "FAILED")?.length || 0;
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            },
        },
    ];

    return (
        <ReactTableDataGrid
            tableName="analyticShopTableProducts"
            idProperty="_id"
            height={350}
            columns={columns}
            rowData={data}
            defaultColDef={defaultColDef}
            gridOptions={{
                reactiveCustomComponents: true,
            }}
            totalSize={totalSize}
            paginationPageSize={sizePerPage}
            emptyText={"No data!"}
            rowSelection="multiple"
            sizePerPageList={getSizePerPageList(totalSize)}
            onTableChanged={(data) => {
                if (data.limit) setSizePerPage(data.limit);
                onTableChange?.(data)
            }}
            groupButton={() => <></>}
            isSearchText={false}
        />
    );
};

export default ShopData;
